(function(angular){
	'use strict';

	angular
		.module('portfolioAllocationChartModule', [
			'coreModule',
			'localStorageModule',
			'reitElementListingModule'
		]);
})(window.angular);